import { render, staticRenderFns } from "./RenderDetails.vue?vue&type=template&id=2a5c03b8&"
import script from "./RenderDetails.vue?vue&type=script&lang=js&"
export * from "./RenderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports